import { Validators } from '@angular/forms';
import { ClientUtils } from 'src/app/utils/client.utils';
import { ClientDomain } from '../../../product-capture/product-capture-details/overview/documents-tab/request-modal/request-modal.consts';
import { micFormatValidator } from '../../validators/mic-format.validator';
import { TableCols } from '../interfaces/static-data';

const timeValidatorPattern = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;

export const EXCHANGES: TableCols[] = [
  {
    key: 'longName',
    displayValue: 'Exchange Name',
    validators: [Validators.required],
  },
  {
    key: 'description',
    displayValue: 'Description',
  },
  {
    key: 'micCode',
    displayValue: 'MIC Code',
    validators: [micFormatValidator()],
  },
  {
    key: 'tradingCalendar',
    displayValue: 'Trading Calendar',
    type: 'select',
    items: [],
    valueGetter: (value: any) => value.tradingCalendar || '-',
    format: (value: any) => value.tradingCalendar || '-',
    filterValueGetter: ({data}) => data.tradingCalendar,
  },
  {
    key: 'tradingStartTime',
    displayValue: 'Trading Start Time',
    mask: 'Hh:m0:s0',
    valueGetter: (value: any) => value.tradingStartTime || '-',
    format: (value: any) => value.tradingStartTime || '-',
    filterValueGetter: ({data}) => data.tradingStartTime,
    defaultValue: '00:00:00',
    customErrorMessage: 'Please enter a valid time in HH:MM:SS format',
    validators: [Validators.pattern(timeValidatorPattern)],
  },
  {
    key: 'tradingEndTime',
    displayValue: 'Trading End Time',
    mask: 'Hh:m0:s0',
    valueGetter: (value: any) => value.tradingEndTime || '-',
    format: (value: any) => value.tradingEndTime || '-',
    filterValueGetter: ({data}) => data.tradingEndTime,
    defaultValue: '00:00:00',
    customErrorMessage: 'Please enter a valid time in HH:MM:SS format',
    validators: [Validators.pattern(timeValidatorPattern)],
  },
  {
    key: 'region',
    displayValue: 'Region',
    type: ClientUtils.isClient(ClientDomain.DeutscheBank) ? 'select' : 'input',
    items: [
      { id: 'Europe', displayValue: 'Europe' },
      { id: 'America', displayValue: 'America' },
      { id: 'Asia', displayValue: 'Asia' }
    ],
  },
  {
    key: 'currencyId',
    displayValue: 'Currency',
    type: 'select',
    items: [],
    selectOptions: {
      searchable: true,
    },
  },
  // COR-3725
  {
    key: 'lastUpdatedBy',
    displayValue: 'Last Updated By',
    hideOnForm: true
  },
  {
    key: 'updatedOn',
    displayValue: 'Updated On',
    hideOnForm: true
  }
];
